export enum UserDataActionType {
  SET_USERDATA = 'set_userdata',
}
